/*
 * @Descripttion:
 * @Author: baiyang
 * @Date: 2022-03-08 13:52:02
 * @LastEditors: baiyang
 * @LastEditTime: 2022-03-08 13:52:03
 */
import FsLogger from 'fshows-logger'

const logger = new FsLogger({
  url: 'https://event-upload.51fubei.com/common/event/synEvent/json',
  data() {
    return {
      AppId: 'fs-advertisement-log',
      adUser: 'OtherWay'// 微邮付
    }
  }
})

export default logger
